export default "__VITE_ASSET__DmjZlPJ2__"